import React, { useEffect } from 'react';
import { useAdmin } from '../context/AdminContext';
import { useNavigate } from 'react-router-dom';

const ProtectedRoute = ({ children, requireOwner = null, redirectTo = '/admin/login' }) => {
  const { admin, isAuthenticated, isLoading } = useAdmin();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      // If not authenticated, redirect to login
      if (!isAuthenticated) {
        navigate('/admin/login');
        return;
      }

      // If requireOwner is specified, check owner field
      if (requireOwner !== null) {
        if (requireOwner === 'admin' && admin?.owner !== 'admin') {
          // Trying to access admin page without admin owner
          console.log('🚫 Non-admin user trying to access admin page, redirecting to streamer dashboard');
          navigate('/streamer/dashboard');
          return;
        }
        
        if (requireOwner === 'not-admin' && admin?.owner === 'admin') {
          // Trying to access streamer page with admin owner
          console.log('🚫 Admin trying to access streamer page, redirecting to admin dashboard');
          navigate('/admin/dashboard');
          return;
        }
      }
    }
  }, [admin, isAuthenticated, isLoading, navigate, requireOwner, redirectTo]);

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  // Show nothing while redirecting
  if (!isAuthenticated) {
    return null;
  }

  // Check owner requirements
  if (requireOwner === 'admin' && admin?.owner !== 'admin') {
    return null;
  }
  
  if (requireOwner === 'not-admin' && admin?.owner === 'admin') {
    return null;
  }

  // Render children if all checks pass
  return children;
};

export default ProtectedRoute; 